var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"heart-rate-history"},[_c('list',{attrs:{"loading":_vm.loading,"show-more":false,"list":_vm.list,"finished":_vm.finished},on:{"update:loading":function($event){_vm.loading=$event},"load":_vm.getList,"onUpdate":_vm.clickEdit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }